module.exports = __webpack_public_path__ + "static/media/card-reusable-cup@2x.cbff9d94.png";